/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1AccessLogin200,
  PostApiV1AccessLogin400,
  PostApiV1AccessLogin500,
  PostApiV1AccessLoginMutationRequest,
  PostApiV1AccessLoginMutationResponse,
} from "../../types/accessController/PostApiV1AccessLogin.ts";
import { loginResultViewModelSchema } from "../loginResultViewModelSchema.ts";
import { loginViewModelSchema } from "../loginViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1AccessLogin200Schema = z.lazy(
  () => loginResultViewModelSchema,
) as unknown as ToZod<PostApiV1AccessLogin200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1AccessLogin400Schema =
  z.any() as unknown as ToZod<PostApiV1AccessLogin400>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1AccessLogin500Schema =
  z.any() as unknown as ToZod<PostApiV1AccessLogin500>;

export const postApiV1AccessLoginMutationRequestSchema = z.lazy(
  () => loginViewModelSchema,
) as unknown as ToZod<PostApiV1AccessLoginMutationRequest>;

export const postApiV1AccessLoginMutationResponseSchema = z.lazy(
  () => postApiV1AccessLogin200Schema,
) as unknown as ToZod<PostApiV1AccessLoginMutationResponse>;
